import { SUPERADMIN_ROLE } from '../../constants';

export const fetchIsMerchant = (state) => state?.user?.isMerchant;
export const fetchUserName = (state) => state?.user?.user;
export const fetchUserToken = (state) => state.user.token;
export const fetchUserEmail = (state) => state.user.email;
export const fetchUserRole = (state) => state?.user?.role;
export const fetchUserId = (state) => state.user.userId;
export const fetchProfileIcon = (state) => state.user.profileIcon;
export const fetchTokenExpiration = (state) => state.user.expiration;

export const isAdminRole = (state) => state?.user?.role === SUPERADMIN_ROLE;
